module.exports = __webpack_public_path__ + "img/icon-oncology-inactive.1a9e737f.png";